export default "__VITE_ASSET__BP$OeI94__"